import HistoricoSection from '@atendimento/detail/historico/components/HistoricoSection'
import HistoricoDetailTable from '@atendimento/detail/historico/components/table/HistoricoDetailTable'
import { historicoSubsectionStyles } from '@atendimento/detail/historico/model/model-historico'
import { naoRegistradoNesseAtendimento } from '@atendimento/detail/historico/utils/utils-historico'
import { Flow, Heading, Text } from 'bold-ui'
import { Ciap, FatoAtendimentoIndividual } from 'graphql/types.generated'
import { isEmpty } from 'util/validation/Util'

import { isFiltroPreenchido } from '../utils-HistoricoDwCiapFiltro'
import { HistoricoCiapProcedimento } from './HistoricoCiapProcedimento'

type HistoricoDwSubjetivoProps = Pick<
  FatoAtendimentoIndividual,
  'id' | 'filtroCiapMotivoConsulta' | 'fatoAppAtendimento'
>

interface HistoricoDwSubjetivoSectionProps {
  historico: HistoricoDwSubjetivoProps
  ciap2Filtro: Ciap[]
}

export const HistoricoDwSubjetivoSection = (props: Readonly<HistoricoDwSubjetivoSectionProps>) => {
  const { historico, ciap2Filtro } = props

  const hasSubjetivo =
    !isEmpty(historico.fatoAppAtendimento?.campoAbertoSubjetivo) ||
    isFiltroPreenchido(historico.filtroCiapMotivoConsulta)

  return (
    <HistoricoSection section='S'>
      {hasSubjetivo ? (
        <Flow direction='vertical' gap={0.5}>
          {!isEmpty(historico.fatoAppAtendimento?.campoAbertoSubjetivo) && (
            <Text>{historico.fatoAppAtendimento?.campoAbertoSubjetivo}</Text>
          )}
          {isFiltroPreenchido(historico.filtroCiapMotivoConsulta) && (
            <Flow direction='vertical' gap={0.5}>
              <Heading level={5} style={historicoSubsectionStyles.subjetivo}>
                Motivo da Consulta
              </Heading>
              <HistoricoDetailTable hasLines>
                <HistoricoCiapProcedimento
                  filtro={historico.filtroCiapMotivoConsulta}
                  ciaps={ciap2Filtro}
                  showLabel={false}
                />
              </HistoricoDetailTable>
            </Flow>
          )}
        </Flow>
      ) : (
        <Text fontStyle='italic'>{naoRegistradoNesseAtendimento}</Text>
      )}
    </HistoricoSection>
  )
}
